import React from 'react'

import { Row, Col, Tag, Alert, Table, Button, Popconfirm, Divider } from 'antd'
import {
  EditOutlined,
  DeleteOutlined,
  PlusOutlined,
  LikeTwoTone,
  DislikeTwoTone,
  CloseCircleTwoTone
} from '@ant-design/icons'

import FormModal, { defaultValue, TYPE_PAYPAL, TYPE_BANK_TRANSFER } from './form'

const columnsAntd = (readOnly, update, remove, existReview) => [
  {
    title: 'Type',
    dataIndex: 'type',
    key: 'type',
    ellipsis: true
  },
  {
    title: 'Information',
    key: 'information',
    ellipsis: true,
    render: (text, record) => {
      if (record.type === TYPE_BANK_TRANSFER) {
        return (
          <>
            <b>Bank Name: </b> {record.bank_name} <br />
            <b>Account Holder: </b> {record.account_holder} <br />
            <b>Account Number: </b> {record.account_number}
            <br />
            <b>Swift/BIC: </b> {record.swift_code} <br />
            <b>ABA/ACH: </b> {record.aba_ach_code} <br />
            <b>Currency: </b> {record.currency} <br />
          </>
        )
      } else if (record.type === TYPE_PAYPAL) {
        return (
          <>
            <b>Email: </b>
            {record.email}
          </>
        )
      } else {
        return (
          <>
            <b>Information: </b>
            {record.information}
          </>
        )
      }
    }
  },
  {
    title: 'Notes',
    dataIndex: 'notes',
    key: 'notes',
    ellipsis: true
  },
  {
    title: 'Action',
    key: 'action',
    render: (text, record) => {
      if (record.review) {
        return (
          <p>
            <Tag color='green'>New</Tag>
          </p>
        )
      }

      if (existReview) {
        return (
          <p>
            <Tag color='red'>Old</Tag>
          </p>
        )
      }
      return (
        <div>
          <Button icon={<EditOutlined />} size='small' onClick={() => update(record)}>
            Update
          </Button>
          {remove && (
            <>
              <Divider type='vertical' />
              <Popconfirm
                title='Are you sure?'
                onConfirm={() => remove(record.id)}
                okText='Yes'
                cancelText='No'
              >
                <Button icon={<DeleteOutlined />} size='small'>
                  Delete
                </Button>
              </Popconfirm>
            </>
          )}
        </div>
      )
    }
  }
]

export default class PaymentMethod extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      modalVisible: false,
      item: defaultValue
    }
  }

  showModal = (item) => {
    this.setState({ item: item, modalVisible: true })
  }

  handelCancel = () => {
    this.setState({ item: { ...defaultValue.type }, modalVisible: false })
  }

  _deletePaymentMethod = (vendorId) => {
    if (!this.props.readOnly && this.props.deletePaymentMethod) {
      return this.props.deletePaymentMethod(vendorId)
    }
  }

  render () {
    const { readOnly, vendor } = this.props
    const existReview = (vendor.payment_methods_review || []).length > 0

    const toReview = (vendor.payment_methods_review || []).map((item) => {
      item.review = true
      item.id = `${item.id}-review`
      return item
    })

    const paymentMethods = vendor.payment_methods || []

    const list = [...paymentMethods, ...toReview]

    return (
      <>
        <Table
          ghost={false}
          columns={columnsAntd(
            this.props.readOnly,
            this.showModal,
            this._deletePaymentMethod(vendor.id),
            existReview
          )}
          dataSource={list}
          rowKey={(row) => row.id}
          bordered
          pagination={false}
          title={() => (
            <>
              {!readOnly &&
                  (vendor.payment_methods || []).length < 1 &&
                  (vendor.payment_methods_review || []).length < 1 && (
                    <Row>
                      <Col flex='auto' align='right'>
                        <Button
                          type='primary'
                          size='small'
                          onClick={() => this.showModal(defaultValue)}
                          icon={<PlusOutlined />}
                        >
                          Payment Method
                        </Button>
                      </Col>
                    </Row>
                  )}
                  {(vendor.payment_methods_review || []).length > 0 && (
                    <Row>
                      <Col flex='auto'>
                        <Alert
                          type='warning'
                          message='Payment method changes are waiting for review.'
                          banner
                          showIcon
                        />
                      </Col>
                      {this.props.validateChanges && this.props.rejectChanges && (
                        <Col flex='240px' style={{ paddingTop: '4px' }} align='right'>
                          <Button
                            onClick={this.props.validateChanges}
                            icon={
                              <>
                                <LikeTwoTone twoToneColor='#52c41a' />{' '}
                                <Divider type='vertical' />
                              </>
                            }
                          >
                            Validate{' '}
                          </Button>
                          <Divider type='vertical' />
                          <Button
                            onClick={this.props.rejectChanges}
                            icon={
                              <>
                                <DislikeTwoTone twoToneColor='#eb2f96' />
                                <Divider type='vertical' />
                              </>
                            }
                          >
                            Reject
                          </Button>
                        </Col>
                      )}
                      {this.props.cancelChanges && (
                        <Col flex='160px' style={{ paddingTop: '4px' }} align='right'>
                          <Button
                            onClick={() => this.props.cancelChanges()}
                            icon={
                              <>
                                <CloseCircleTwoTone />
                                <Divider type='vertical' />
                              </>
                            }
                          >
                            Cancel Review
                          </Button>
                        </Col>
                      )}
                    </Row>
                  )}
                </>
              )}
        size='middle'
        scroll={{ x: 900 }}
                />

                <FormModal
                    updatePaymentMethod={this.props.updatePaymentMethod}
                    vendor={this.props.vendor}
                    item={this.state.item}
                    onCancel={this.handelCancel}
                    modalVisible={this.state.modalVisible}
                />
            </>
        )
    }
}
